<div class="mt-3" *ngIf="style === tableStyle.Short">
  <div class="table-title card-header" [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
        {{store.title}}
      </h4>
      <a>
        <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i class="fa fa-info-circle fa-sm"></i></button>
      </a>
    </div>
  </div>
  <div class="table-responsive" [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="sendSortingParam($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="Sottostante">Sottostante</th>
          <th scope="col" mat-sort-header="Ultimo">Ultimo</th>
          <th scope="col" mat-sort-header="Var%">Var % (1 gg)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.sortedRecords">
          <td><a [routerLink]="['/menu/sottostante']" [queryParams]="{sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a></td>
          <td [style.color]=" record.ultimo < 0 ? 'red' : 'null'">
            {{record.ultimo ? (record.ultimo | number :'1.0-2':'it') : '--'}}
          </td>
          <td [style.color]=" record.var < 0 ? 'red' : 'null'">
            {{record.var ? (record.var/100 | percent:'1.0-2':'fr') : '--'}}
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="!showLoader" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="store.viewAllPath">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <app-loader *ngIf="showLoader"></app-loader>
    </div>
  </div>

</div>

<div class="container-fluid mt-3" style="position: relative" *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="view-all-table-title">
      {{store.title}}
    </h4>
    <mat-form-field class="ml-auto" *ngIf="store.totalRecords > 20">
      <mat-label>Elementi per pagina</mat-label>
      <select matNativeControl (change)="updateSize($event)">
        <option value="20" selected>20</option>
        <option value="30">30</option>
        <option value="40">40</option>
      </select>
    </mat-form-field>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i class="fa fa-info-circle fa-sm"></i></button>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="deepSortRecords($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="sottostante">Sottostante</th>
          <th scope="col" mat-sort-header="id">Id</th>
          <th scope="col" mat-sort-header="ultimo">Ultimo</th>
          <th scope="col" mat-sort-header="var">Var % (1 gg)</th>
          <th scope="col" mat-sort-header="var5gg">Var % (5 gg)</th>
          <th scope="col" mat-sort-header="varianno">Var % Inizio Anno</th>
          <th scope="col" mat-sort-header="varanno">Var % 1 Anno</th>
          <th scope="col" mat-sort-header="max52sett">Max 52 Sett.</th>
          <th scope="col" mat-sort-header="min52sett">Min 52 Sett.</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.allSortedRecords">
          <td><a [routerLink]="['/menu/sottostante']" [queryParams]="{sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a></td>
          <td>{{record.id ? record.id : '--'}}</td>
          <td [style.color]=" record.ultimo < 0 ? 'red' : 'null'">
            {{record.ultimo ? (record.ultimo | number:'1.0-2':'it') : '--'}}
          </td>
          <td [style.color]=" record.var < 0 ? 'red' : 'null'">
            {{record.var ? (record.var/100 | percent:'1.0-2':'fr') : '--'}}
          </td>
          <td [style.color]=" record.var < 0 ? 'red' : 'null'">
            {{record.var5gg ? (record.var5gg/100 | percent:'1.0-2':'fr') : '--'}}
          </td>
          <td [style.color]=" record.var < 0 ? 'red' : 'null'">
            {{record.varianno ? (record.varianno/100 | percent:'1.0-2':'fr') : '--'}}
          </td>
          <td [style.color]=" record.var < 0 ? 'red' : 'null'">
            {{record.varAnno ? (record.varAnno/100 | percent:'1.0-2':'fr') : '--'}}
          </td>
          <td>{{record.max52sett ? (record.max52sett | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.min52sett ? (record.min52sett | number:'1.0-2':'fr') : '--'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div style="padding-top: 15px" *ngIf="store.totalRecords > pageSize">
    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li class="page-item">
          <a class="page-link" (click)="firstPage()">First</a>
        </li>
        <li [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="previousPage()" title="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item active">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="nextPage()" title="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="lastPage()">Last</a>
        </li>
      </ul>
    </nav>
  </div>
  <div [ngClass]="showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="showLoader"></app-loader>
  </div>
</div>
